import { FunctionComponent } from "react";
import NumberFormat from "react-number-format";
import SocialTwitter from "./images/social-twitter.svg";
import SocialFacebook from "./images/social-facebook.svg";
import SocialTelegram from "./images/social-telegram.svg";
import SocialGithub from "./images/social-github.svg";
import SocialMail from "./images/social-mail.svg";
import SocialMedium from "./images/social-medium.svg";
import "./PoolPageAbout.scss";

const PoolPageAbout: FunctionComponent<{}> = () => {
    return (
        <>
            <div className={"pool-page-about"}>
                <div className='about-project'>
                    <span className='title brand-color-white'>
                        About Project
                    </span>
                    <p className='about-summary'>
                        Blocklauncher revolutionizes the way gas-was-encourager
                        ICOs used to raise funds by incorporating a
                        community-governed IDO launchpad in a secured manner.
                        Gone are the days when investors need to be worried
                        about rug pull aka scams because of our automatic
                        (sufficient) liquidly locking mechanism. Community can
                        directly access high-quality crypto projects via private
                        and public rounds whilst projects enjoy piece of mind
                        from creating token pools and distributing tokens.
                    </p>
                    <p className='about-summary'>
                        Blocklauncher offers the safe and decentralized
                        ecosystem to both investors and project owners to grow
                        together in this disruptive crypto space.
                    </p>
                    <span className='d-flex justify-content-flex-start'>
                        <a href='/home' className='mr-3'>
                            <img
                                alt='social facebook'
                                className='pool-socials'
                                src={SocialFacebook}
                            ></img>
                        </a>
                        <a href='/home' className='mr-3'>
                            <img
                                alt='social twitter'
                                className='pool-socials'
                                src={SocialTwitter}
                            ></img>
                        </a>
                        <a href='/home' className='mr-3'>
                            <img
                                alt='social telegram'
                                className='pool-socials'
                                src={SocialTelegram}
                            ></img>
                        </a>
                        <a href='/home' className='mr-3'>
                            <img
                                alt='social medium'
                                className='pool-socials'
                                src={SocialMedium}
                            ></img>
                        </a>
                        <a href='/home' className='mr-3'>
                            <img
                                alt='social github'
                                className='pool-socials'
                                src={SocialGithub}
                            ></img>
                        </a>
                        <a href='/home' className='mr-3'>
                            <img
                                alt='social email'
                                className='pool-socials'
                                src={SocialMail}
                            ></img>
                        </a>
                    </span>
                </div>
                <div className='token-summary'>
                    <span className='brand-color-white title'>
                        Token Summary
                    </span>
                    <table>
                        <tbody>
                            <tr>
                                <td>TICKER</td>
                                <td>ABC</td>
                            </tr>
                            <tr>
                                <td>TYPE</td>
                                <td>BEP-20</td>
                            </tr>
                            <tr>
                                <td>TOTAL SUPPLY</td>
                                <td>
                                    <NumberFormat
                                        thousandSeparator={true}
                                        displayType='text'
                                        value={10000000}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>TOKEN FOR SALE</td>
                                <td>
                                    <NumberFormat
                                        displayType='text'
                                        thousandSeparator={true}
                                        value={2500000}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>INITIAL CIRCULATION</td>
                                <td>
                                    <NumberFormat
                                        displayType='text'
                                        thousandSeparator={true}
                                        value={1000000}
                                        suffix={" $ABC"}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>LIQUIDLY LOCK</td>
                                <td>YES (500,000 $ABC)</td>
                            </tr>
                            <tr>
                                <td>SALE STARTS</td>
                                <td>02 May, 2021 00:00 UTC</td>
                            </tr>
                            <tr>
                                <td>SALE ENDS</td>
                                <td>03 May, 2021 00:00 UTC</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default PoolPageAbout;
